export const ENABLED_SHIPPERS_ITEM_KEY = 'transportMs.enabledShippers';

export function parseEnabledShippersCsv(raw: string | null | undefined): string[] {
    if (!raw) {
        return [];
    }
    const seen = new Set<string>();
    const out: string[] = [];
    for (const part of raw.split(',')) {
        const code = part.trim();
        if (!code) {
            continue;
        }
        const key = code.toUpperCase();
        if (seen.has(key)) {
            continue;
        }
        seen.add(key);
        out.push(code);
    }
    return out;
}

export function uniqueShipperCodes(
    serviceCodes: ReadonlyArray<{ shipperCode?: string }>,
    storedCsv: string | null | undefined
): string[] {
    const byUpper = new Map<string, string>();
    for (const item of serviceCodes) {
        const code = item.shipperCode?.trim();
        if (!code) {
            continue;
        }
        const key = code.toUpperCase();
        if (!byUpper.has(key)) {
            byUpper.set(key, code);
        }
    }
    for (const code of parseEnabledShippersCsv(storedCsv)) {
        const key = code.toUpperCase();
        if (!byUpper.has(key)) {
            byUpper.set(key, code);
        }
    }
    return Array.from(byUpper.values()).sort((a, b) => a.localeCompare(b));
}

export function formatEnabledShippersSummary(selected: string[]): string | null {
    if (selected.length === 0) {
        return null;
    }
    if (selected.length === 1) {
        return selected[0];
    }
    return `${selected[0]} +${selected.length - 1}`;
}

export function toggleEnabledShipper(
    selectedCsv: string,
    shipperCode: string,
    optionOrder: readonly string[]
): string {
    const selected = new Set(parseEnabledShippersCsv(selectedCsv).map((code) => code.toUpperCase()));
    const key = shipperCode.trim().toUpperCase();
    if (!key) {
        return optionOrder.filter((code) => selected.has(code.toUpperCase())).join(',');
    }
    if (selected.has(key)) {
        selected.delete(key);
    } else {
        selected.add(key);
    }
    return optionOrder.filter((code) => selected.has(code.toUpperCase())).join(',');
}
